<template>
  <div>
    <v-container>
      <v-row>
        <div
          class="d-flex justify-space-between mb-6"
          style="width: 100%;"
        >
          <SectionTitle :title="$t('main.enums.sections.contact_infos')" />
        </div>
        <v-col
          cols="12"
          class="mb-1"
        >
          <SmallSectionTitle
            section-number="1"
            :title="$t('main.enums.sections.contact_infos')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="displayField['email']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['email']"
            :isError="checks.email"
            :label="$t('main.enums.fields.email')"
            :value="selectedProfile.email"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['home_phone_number']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['home_phone_number']"
            :isError="checks.home_phone_number"
            :label="$t('main.enums.fields.home_phone_number')"
            :value="homePhone"
            format="phone"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['mobile_phone_number']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['mobile_phone_number']"
            :isError="checks.mobile_phone_number"
            :label="$t('main.enums.fields.mobile_phone_number')"
            :value="mobilePhone"
            format="phone"
            color="purple"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="mb-1"
        >
          <SmallSectionTitle
            section-number="2"
            :title="$t('main.enums.sections.postal_infos')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="displayField['home_address_line_1']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['home_address_line_1']"
            :isError="checks.home_address_line_1"
            :label="$t('main.enums.fields.home_address_line_1')"
            :value="selectedProfile.home_address_line_1"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['home_address_line_2']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['home_address_line_2']"
            :isError="checks.home_address_line_2"
            :label="$t('main.enums.fields.home_address_line_2')"
            :value="selectedProfile.home_address_line_2"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['home_address_line_3']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['home_address_line_3']"
            :isError="checks.home_address_line_3"
            :label="$t('main.enums.fields.home_address_line_3')"
            :value="selectedProfile.home_address_line_3"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['home_country']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['home_country']"
            :isError="checks.home_country"
            :label="$t('main.enums.fields.home_country')"
            :value="selectedProfile.home_country"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayHomeCity && displayField['home_insee_code']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['home_insee_code']"
            :isError="checks.home_insee_code"
            :label="$t('main.enums.fields.home_insee_code')"
            :value="selectedHomeCity"
            color="purple"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script type="text/javascript">
  import mixinUi from '@/mixins/utils/ui.js'
  import CommonMixin from '@/mixins/store/CommonMixin.js'
  import { getFieldsByProperty } from '@/utils/person.utils'

  import SmallSectionTitle from '@/components/ui/common/SmallSectionTitle'
  import SectionTitle from '@/components/ui/common/SectionTitle'
  import LabelledFieldAlt from '@/components/ui/common/LabelledFieldAlt'

  import personTabFields from '@/components/RightDrawer/helpers/PersonTab.fields.json'

  export default {
    components: {
      SectionTitle,
      SmallSectionTitle,
      LabelledFieldAlt,
    },
    mixins: [mixinUi, CommonMixin,],
    data() {
      return {
        localFields: personTabFields.contact,
        checks: {},
      }
    },
    computed: {
      displayField() {
        const allFields = this.requiredAttributes.concat(this.optionalAttributes)

        return getFieldsByProperty(allFields, this.localFields)
      },
      isRequired() {
        return getFieldsByProperty(this.requiredAttributes, this.localFields)
      },
      homePhone() {
        if (!this.selectedProfile.home_phone_number) return ''

        return this.selectedProfile.home_phone_number.replace(/\B(?=(\d{2})+(?!\d))/g, ' ')
      },
      mobilePhone() {
        if (!this.selectedProfile.mobile_phone_number) return ''

        return this.selectedProfile.mobile_phone_number.replace(/\B(?=(\d{2})+(?!\d))/g, ' ')
      },
      displayHomeCity() {
        return this.selectedProfile.home_country === 'FRANCE'
      },
      selectedHomeCity() {
        if (this.selectedProfile.home_insee_code === null) {
          return null
        }
        const cities = this.currentConfig.enums.french_cities_with_state
        const city = cities[this.selectedProfile.home_insee_code]

        return city ? `${String(city.dep).padStart(2, '0')} - ${city.libelle}` : null
      },
    },
    mounted() {
      this.checks = this.selectedProfile.person_controls[0].checks
    },
  }
</script>
